import ClockoutController from '../../core/clockout.controller';

/**
 * @extends ClockoutController
 */
class InvalidInvitationController extends ClockoutController {
    async initialize() {
        // No initialization needed
    }

    async cleanup() {
        // No cleanup needed
    }

    navigateLogin() {
        window.location.href = '/';
    }
}

export default InvalidInvitationController;

